import { ArrowHeadRightIcon, Button } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { BpCard } from '../BpCard/BpCard';
import styles from './AnswersCard.module.scss';
import { BpTipTapText } from '../BpTipTapText/BpTipTapText';
import { FragmentType, getFragmentData, graphql } from 'client/gql';

const AnswersCardFieldsDocument = graphql(`
  fragment AnswersCardFields on Query {
    submissionsForAnswersCard: submissions(
      where: { public: true, assignmentConnection_SINGLE: { node: { uuid: $assignmentUuid } } }
    ) {
      uuid
      __typename
      owner {
        uuid
        __typename
        firstName
        lastName
      }
      material {
        uuid
        __typename
        text
      }
    }
  }
`);

type AnswersCardProps = {
  onNavigate: (submissionUuid: string) => void;
  query: FragmentType<typeof AnswersCardFieldsDocument> | undefined;
};

export const AnswersCard: FC<AnswersCardProps> = ({ onNavigate, query }) => {
  const { t } = useTranslation();

  const fragment = getFragmentData(AnswersCardFieldsDocument, query);
  const submissions = fragment?.submissionsForAnswersCard;

  const onClick = (submissionUuid: string) => {
    onNavigate(submissionUuid);
  };

  return (
    <>
      {submissions && submissions.length > 0 && (
        <BpCard header={{ headline: t('submissions.publicised') }}>
          <>
            {submissions.map((s) => {
              const profile = s.owner;
              const name = `${profile?.firstName} ${profile?.lastName}`;

              return (
                <div key={s.uuid} className={styles.answer}>
                  <div className={styles.top}>
                    <div className={styles.name}>
                      {t('submissions.answerFrom')} {name}
                    </div>
                    <Button
                      className={styles.button}
                      onClick={() => onClick(s.uuid)}
                      hierarchy='tertiary'
                      icon={<ArrowHeadRightIcon />}
                    />
                  </div>
                  <BpTipTapText embedded content={s.material.text ?? ''} />
                </div>
              );
            })}
          </>
        </BpCard>
      )}
    </>
  );
};
